import React from 'react'
import { Grid } from '@mui/material'
import { CursoEscolarSelect } from 'components/forms/components/Select/custom'

export default function CursoExtranjeroTemplate({ register, errors, reset, setValue }) {
    return (
        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={4}>

            <Grid item xs={2}>
                <CursoEscolarSelect label={'Año'} name={`ano`} register={register} errors={errors} wantToReset={reset} defaultValue={null} setValue={setValue} searcheable />
            </Grid>

            <Grid item xs={3} border={'1px solid red'}>
                tipo curso
            </Grid>

        </Grid>
    )
}
